export enum ECompany {
  TELEFONICA = 0,
  TUENTI = 1,
  CLARO = 3
}
